import { createContext } from 'react';
export const SearchContext = /*#__PURE__*/createContext({
  setSearchString: () => void 0,
  isFiltered: false,
  filteredItems: []
});